var Backbone, SupportFlexibleContactChannelModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportFlexibleContactChannelModel = (function(superClass) {
  extend(SupportFlexibleContactChannelModel, superClass);

  function SupportFlexibleContactChannelModel() {
    return SupportFlexibleContactChannelModel.__super__.constructor.apply(this, arguments);
  }

  SupportFlexibleContactChannelModel.prototype.initialize = function() {
    return this.url = window.SUPPORTBASEURL + "/fetch?key=contact_channels&type=contact_channels";
  };

  SupportFlexibleContactChannelModel.prototype.setFetchContactChannelFromCMS = function() {
    return this.url = this.url + "&should_display_cms_content=true";
  };

  SupportFlexibleContactChannelModel.prototype.hasContactChannels = function() {
    return this.has('contact_channels');
  };

  SupportFlexibleContactChannelModel.prototype.getContactChannels = function() {
    return this.get('contact_channels');
  };

  SupportFlexibleContactChannelModel.prototype.setFlexibleContactChannels = function(contactChannelsForSelectedSubcategory) {
    return this.set("flexbleContactChannels", contactChannelsForSelectedSubcategory);
  };

  SupportFlexibleContactChannelModel.prototype.invalidateFlexibleContactChannels = function() {
    return this.set("flexbleContactChannels", null);
  };

  SupportFlexibleContactChannelModel.prototype.presentContactChannels = function() {
    var contactChannels, formattedContactChannels;
    if (this.has('flexbleContactChannels')) {
      contactChannels = this.get('flexbleContactChannels');
      formattedContactChannels = [];
      _.each(contactChannels, (function(_this) {
        return function(value, key) {
          var formattedContactChannel;
          key = key != null ? key.toLowerCase() : void 0;
          value = value != null ? value.toLowerCase() : void 0;
          formattedContactChannel = {};
          formattedContactChannel[key] = _this.getContactChannelHash(value);
          if (value === 'chat') {
            _this.set('liveChatExists', true);
          }
          return formattedContactChannels.push(formattedContactChannel);
        };
      })(this));
      this.set("formattedContactChannels", {
        contact_channels: formattedContactChannels
      });
    } else {
      this.set('liveChatExists', true);
      this.set("formattedContactChannels", {
        contact_channels: this.getDefaultContactChannelsWithChat()
      });
    }
    return this.setBoldchatRelatedInfoInFlexibleContactChannels();
  };

  SupportFlexibleContactChannelModel.prototype.setBoldchatRelatedInfoInFlexibleContactChannels = function() {
    var formattedContactChannels, ref, ref1;
    if (this.has('formattedContactChannels')) {
      formattedContactChannels = this.get("formattedContactChannels")['contact_channels'];
      this.set('primaryChannelIsBoldChat', (formattedContactChannels != null ? (ref = formattedContactChannels[0]) != null ? (ref1 = ref['primary']) != null ? ref1.is_chat : void 0 : void 0 : void 0) === true);
      this.set('onlyBoldChatInContactChannels', (formattedContactChannels.length === 1) && this.get('primaryChannelIsBoldChat'));
    }
    return this.setContactChannelsWithoutBoldChat();
  };

  SupportFlexibleContactChannelModel.prototype.setContactChannelsWithoutBoldChat = function() {
    var channelTypes, contactChannelsWithoutBoldChat, contact_channels, i;
    if (this.get('onlyBoldChatInContactChannels')) {
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: [
          {
            primary: this.getContactChannelHash("email")
          }
        ]
      });
    } else if (this.has('formattedContactChannels')) {
      channelTypes = ['primary', 'secondary', 'tertiary'];
      i = 0;
      contactChannelsWithoutBoldChat = [{}, {}, {}];
      contact_channels = _.each(this.get("formattedContactChannels").contact_channels, function(formattedContactChannel, key) {
        var ref;
        if (!((ref = formattedContactChannel[channelTypes[key]]) != null ? ref.is_chat : void 0)) {
          return contactChannelsWithoutBoldChat[i][channelTypes[i++]] = formattedContactChannel[channelTypes[key]];
        }
      });
      _.each(contactChannelsWithoutBoldChat, function(contactChannelWithoutBoldChat, key) {
        if (_.isEmpty(contactChannelWithoutBoldChat)) {
          return contactChannelsWithoutBoldChat.splice(key, 1);
        }
      });
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: contactChannelsWithoutBoldChat
      });
    } else {
      return this.set("contactChannelsWithoutBoldChat", {
        contact_channels: this.getDefaultContactChannelsWithoutChat()
      });
    }
  };

  SupportFlexibleContactChannelModel.prototype.getDefaultContactChannelsWithChat = function() {
    var contactChannels;
    contactChannels = {
      primary: "chat",
      secondary: "email",
      tertiary: window.isCallBackAvailable ? "phone" : null
    };
    return this.getFilteredChannelsByUserRegisteredAt(contactChannels);
  };

  SupportFlexibleContactChannelModel.prototype.getFilteredChannelsByUserRegisteredAt = function(contactChannels) {
    var result;
    contactChannels = this.filterContactChannelsByUserRegistrationDate(contactChannels);
    result = [];
    _.each(contactChannels, (function(_this) {
      return function(value, key) {
        var curr;
        curr = {};
        curr[key] = _this.getContactChannelHash(value);
        return result = result.concat(curr);
      };
    })(this));
    return result;
  };

  SupportFlexibleContactChannelModel.prototype.getDefaultContactChannelsWithoutChat = function() {
    var contactChannels;
    contactChannels = {
      primary: "email",
      secondary: window.isCallBackAvailable ? "phone" : null
    };
    return this.getFilteredChannelsByUserRegisteredAt(contactChannels);
  };

  SupportFlexibleContactChannelModel.prototype.getContactChannelHash = function(type) {
    switch (type) {
      case "chat":
        return this.chatContactChannelHash();
      case "email":
        return this.emailContactChannelHash();
      case "phone":
        return this.phoneContactChannelHash();
    }
  };

  SupportFlexibleContactChannelModel.prototype.chatContactChannelHash = function() {
    return {
      "channel": "chat",
      button_text: I18n.translate('js.modules.support.chat'),
      channel_text: I18n.translate('js.modules.support.chat_us'),
      is_chat: true
    };
  };

  SupportFlexibleContactChannelModel.prototype.emailContactChannelHash = function() {
    return {
      "channel": "email",
      button_text: I18n.translate('js.modules.support.email'),
      channel_text: I18n.translate('js.modules.support.email_us'),
      is_chat: false
    };
  };

  SupportFlexibleContactChannelModel.prototype.phoneContactChannelHash = function() {
    return {
      "channel": "phone",
      button_text: I18n.translate("js.modules.support.flexible_phone"),
      channel_text: window.evaluate(window.experiments.shouldDisplayCallBackOption) ? I18n.translate('js.modules.support.call_me_back') : I18n.translate('js.modules.support.phone_us'),
      additional_text: window.evaluate(window.experiments.shouldDisplayCallBackOption) ? I18n.translate('js.modules.support.with_our_team') : void 0,
      is_chat: false
    };
  };

  SupportFlexibleContactChannelModel.prototype.removeNullChannels = function(contactChannels) {
    if (_.isEmpty(contactChannels['primary'])) {
      if (_.isEmpty(contactChannels['secondary'])) {
        contactChannels['primary'] = contactChannels['tertiary'];
      } else {
        contactChannels['primary'] = contactChannels['secondary'];
        contactChannels['secondary'] = contactChannels['tertiary'];
      }
      delete contactChannels['tertiary'];
    } else if (_.isEmpty(contactChannels['secondary'])) {
      contactChannels['secondary'] = contactChannels['tertiary'];
      delete contactChannels['tertiary'];
    }
    _.each(contactChannels, (function(_this) {
      return function(value, key) {
        if (value == null) {
          return delete contactChannels[key];
        }
      };
    })(this));
    return contactChannels;
  };

  SupportFlexibleContactChannelModel.prototype.filterContactChannelsByUserRegistrationDate = function(contactChannels) {
    var j, len, suppressChannel, suppressParams;
    suppressParams = window.contactChannelSuppressParams;
    if (suppressParams != null) {
      for (j = 0, len = suppressParams.length; j < len; j++) {
        suppressChannel = suppressParams[j];
        if (suppressChannel != null ? suppressChannel.isUserRegisteredAfterCutoff : void 0) {
          contactChannels = _.omit(contactChannels, (function(_this) {
            return function(value, key, object) {
              return value === (suppressChannel != null ? suppressChannel.contactChannelKeyFilter : void 0);
            };
          })(this));
        }
      }
    }
    return contactChannels = this.removeNullChannels(contactChannels);
  };

  SupportFlexibleContactChannelModel.prototype.getAvailableContactChannelsForCallBack = function(contactChannels) {
    var ref;
    if (window.evaluate((ref = window.experiments) != null ? ref.shouldDisplayCallBackOption : void 0) && (window.isCallBackAvailable != null)) {
      if (window.isCallBackAvailable === false) {
        _.each(contactChannels, (function(_this) {
          return function(value, key) {
            value = value != null ? value.toLowerCase() : void 0;
            if (value === 'phone') {
              return contactChannels[key] = null;
            }
          };
        })(this));
      }
    }
    return contactChannels;
  };

  SupportFlexibleContactChannelModel.prototype.getIndividualContactChannelHash = function(channel, channelHash) {
    var contactChannel;
    contactChannel = {};
    contactChannel[channel] = channelHash;
    return contactChannel;
  };

  SupportFlexibleContactChannelModel.prototype.filterContactChannelHash = function(contactChannelHash, channel) {
    var channelTypes, channelTypesIndex, contactChannels, modifiedContactChannelHash;
    channelTypes = ['secondary', 'tertiary'];
    channelTypesIndex = 0;
    modifiedContactChannelHash = [];
    contactChannels = contactChannelHash.contact_channels;
    contactChannels = _.reject(contactChannels, (function(_this) {
      return function(value, key) {
        var contactChannel, ref;
        contactChannel = _.values(value);
        return ((ref = contactChannel[0]) != null ? ref['channel'] : void 0) === channel;
      };
    })(this));
    _.each(contactChannels, (function(_this) {
      return function(value, key) {
        var contactChannel;
        contactChannel = _.values(value);
        return modifiedContactChannelHash.push(_this.getIndividualContactChannelHash(channelTypes[channelTypesIndex++], contactChannel[0]));
      };
    })(this));
    return {
      'contact_channels': modifiedContactChannelHash
    };
  };

  SupportFlexibleContactChannelModel.prototype.getContactChannelsForCallBack = function(contactChannelHash) {
    return this.filterContactChannelHash(contactChannelHash, 'phone');
  };

  return SupportFlexibleContactChannelModel;

})(Backbone.Model);

module.exports = SupportFlexibleContactChannelModel;

//# sourceMappingURL=data:application/json;base64,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
